import { type PayloadAction, createSlice } from '@reduxjs/toolkit';

import { type SortType } from '@/packages/api-models/common/json_query';
import { type Cluster } from '@/packages/query-state/shared/types/clusters/ClustersResponse';

export type MapControlsState = {
  activePin?: Cluster;
  activePinPage?: number;
  activePinSort: SortType;
  hoveredPinId?: string;
};

const mapControlsInitialState: MapControlsState = {
  activePinSort: 'default',
};

export const { reducer: mapControlsReducer, actions: mapControlsActions } = createSlice({
  initialState: mapControlsInitialState,
  name: 'mapControls',
  reducers: {
    clearActivePin(state) {
      state.activePinSort = 'default';
      delete state.activePin;
      delete state.activePinPage;
    },
    setActivePin(state, action: PayloadAction<Cluster>) {
      state.activePin = action.payload;
      state.activePinSort = 'default';
      delete state.activePinPage;
    },
    setActivePinPage(state, action: PayloadAction<number>) {
      state.activePinPage = action.payload;
    },
    setActivePinSortWithPageReset(state, action: PayloadAction<SortType>) {
      state.activePinSort = action.payload;
      delete state.activePinPage;
    },
    setHoveredPinId(state, action: PayloadAction<string>) {
      state.hoveredPinId = action.payload;
    },
    clearHoveredPinId(state) {
      delete state.hoveredPinId;
    },
  },
});
